var AbstractWS = require("./AbstractWS");
var getQueryParam = require("../helpers/viewmodels").getQueryParam
var xmlToJson = require("../helpers/xmlToJson");

function KioskMessagesWS(parent) {
  var self = this;

  AbstractWS.apply(self, arguments);

  self.allLanguages = ko.observableArray([]);
  self.allLanguageNames = ko.observableArray([]);
  self.bundle = ko.observable(null);
  self.bundles = [];
  self.inited = false;
  self.name = 'KioskMessagesWS' + parent.id;
  self.parent = parent;

  /**
   * Requests data from the API
   *
   * @method doRequest
   * @return
   */
  self.doRequest = function (fCallback, force) {
    var pLang = self.parent.language;
    var defaultLocale = self.getDefaultLocale();
    if (force || !self.inited) {
      var localesParam = (pLang && pLang.length > 0) ? '?locale=' + pLang.join(',') : (defaultLocale ? '?locale=' + defaultLocale : '');

      // Reinitialize the service URL based on the newly
      // calculated localesParam
      self.serviceURL = ko.observable('/qless/api/v1/messages/consumerKiosk/location/' + self.parent.id + localesParam);

      // Make the API call
      // AbstractWS.prototype.doRequest(fCallback);
      AbstractWS.prototype.doRequest.call(self, fCallback);
    }
  };


  /**
   * Retrieves a text string from the current bundle
   *
   * @method get
   * @param {String} sKey
   * @param {Boolean} bStripHTML
   * @return {String}
   */
  self.get = function (sKey, bStripHTML) {
    var aBundle = self.bundle();
    var sVal = '';

    // Ensure there is an active message bundle
    if (aBundle !== null) {
      // Loop over each message object in the active bundle
      aBundle.m.forEach(function (oMessage) {
        // Attempt to locate a message with the provided key
        if (oMessage.n === sKey) {
          // The message must have a body
          if (oMessage.text !== undefined) {
            // Get the body of the message object
            sVal = oMessage.text;
            // Unless explicitly told not to, replace HTML elements
            // found in the message value
            if (bStripHTML !== false) {
              sVal = sVal.replace(/(<([^>]+)>)/ig, '');
            }
            // Replace any newline values with <BR> tags
            sVal = sVal.replace(/\n/g, '<br>');
          }
        }
      });
      return sVal;
    }
    // Likely hit here because there is no message bundle
    return sVal;
  };


  /**
   * Retrieves the default locale from the browser
   * 
   * @method getDefaultLocale
   * @returns {String}
   */
  self.getDefaultLocale = function () {
    // Get the local from the html element of the page
    var locale = vm.getUserLanguage();
    var qLocale = getQueryParam("locale");
    var localeParts = locale.split(/[_-]/);

    // If a locale query param exists, use that instead.
    // If there are many, use the first one
    if (qLocale !== null) {
      // If there are mulitple locales, just use the first one
      locale = qLocale.indexOf(",") > -1 ? qLocale.split(",")[0] : qLocale;
    }
    // Try to use the browser default locale first
    else if (self.parent.language && (self.parent.language.indexOf(locale) > -1 || self.parent.language.indexOf(localeParts[0]) > -1)) {
      return locale;
    }
    // If a locale query param exists, use that instead.
    // If there are many, use the first one
    else if (qLocale !== null) {
      // If there are mulitple locales, just use the first one
      locale = qLocale.indexOf(",") > -1 ? qLocale.split(",")[0] : qLocale;
    }
    //Just use the first locale in the languages array as return from the API
    else if (self.parent.language && self.parent.language.length > 0) {
      return self.parent.language[0];
    }
    // If all else fails, return the browser locale
    return locale;
  };


  /**
   * Sets the current bundle to the specified language string. If the language
   * string was not found, try to load the defaultLocale bundle. If a bundle
   * could still not be found, just load the first language bundle instead.
   *
   * @method setLocale
   * @param {String} sLang	Language identifier token
   * @return
   */
  self.setLocale = function (sLang) {
    if (sLang) {
      var found = false;
      var langName = sLang.toLowerCase();
      var langRoot = langName.substr(0, 2);
      var langExt = langName.substr(3, 2);

      // Start by trying to set the bundle to the assigned bundle
      if (self.bundle() === null && self.bundles && self.bundles.length > 0) {
        self.bundles.forEach(function (bundle) {
          var bundleName = bundle.locale.toLowerCase();
          var bundleRoot = bundleName.substr(0, 2);
          var bundleExt = bundleName.substr(3, 2);

          // Find any direct match if possible, i.e. en = en, es = es
          // en_GB = en_GB, en_ES = en_ES, etc
          if (bundleName === langName) {
            found = true;
            self.bundle(bundle);
          }
          // Account for browser variance in specifying language extensions
          // ie en-GB = en_GB, by examining the root language and the extension
          else if (bundleRoot === langRoot && bundleExt === langExt) {
            found = true;
            self.bundle(bundle);
          }
          // If all else fails, account for language without regard for extension
          else if (bundleRoot === langRoot) {
            found = true;
            self.bundle(bundle);
          }
        });
      }

      // If the specified bundle (language name) could not be found
      // try to set it to the defaultLocale() from the VM.
      if (!found) {
        self.bundles.forEach(function (bundle) {
          if (self.bundle() === null && bundle.locale.toLowerCase() === self.getDefaultLocale()) {
            found = true;
            self.bundle(bundle);
          }
        });
      }

      // If the specified bundle could not be found and the default language
      // bundle could not be found (accounting for logic error in the VM
      // defaultLocale() function), just set the bundle to the first bundle
      if (!found) {
        self.bundle(self.bundles[0]);
      }
    }
  };


  /**
   * Processes API data
   *
   * @method processData
   * @param {XMLDocument} data
   * @return none
   */
  self.processData = function (xmlData) {
    AbstractWS.prototype.processData.call(self, xmlData);

    self.inited = true;
    self.data = xmlData;
    self.json = xmlToJson.parse(xmlData);
    self.bundles = self.json.bundles.bundle || [];

    if (self.json.bundles.bundle instanceof Array === false && self.json.bundles.bundle instanceof Object == true) {
      self.bundles = [self.json.bundles.bundle];
    }

    self.setLocale(self.getDefaultLocale());
  };
};

KioskMessagesWS.prototype = AbstractWS.prototype;
KioskMessagesWS.prototype.constructor = KioskMessagesWS;

module.exports = KioskMessagesWS
